export default function _videoModal() {
    const videoModal = document.querySelectorAll(
        '.video-modal-wrapper__container'
    );

    videoModal.forEach((videoSection) => {
        const transcriptBtn = videoSection.querySelector(
            '.video-modal-wrapper__transcript-section__icon'
        );
        const transcriptSection = videoSection.querySelector(
            '.video-modal-wrapper__transcript-content'
        );
        const transcriptWrapper = videoSection.querySelector(
            '.video-modal-wrapper__transcript-section'
        );

        if (transcriptWrapper) {
            transcriptWrapper.addEventListener('click', () => {
                if (transcriptSection.classList.contains('visible')) {
                    transcriptSection.classList.remove('visible');
                    transcriptBtn.classList.remove('rotate');
                } else {
                    transcriptSection.classList.add('visible');
                    transcriptBtn.classList.add('rotate');
                }
            });
        }
    });
}

_videoModal();
